<template>
    <div>
        <b-card
                header="Filters"
                header-text-variant="white"
                header-bg-variant="info"
        >
            <b-form inline>
                <date-picker
                        v-model="start_date"
                        placeholder="Start Date"
                >
                </date-picker>
                &nbsp;to&nbsp;
                <date-picker
                        v-model="end_date"
                        class="mr-2"
                        placeholder="End Date"
                >
                </date-picker>

                <select class="form-control "disabled>
                    <option selected>Johnson, Stephen</option>
                </select>

                <b-button type="button" variant="info" :disabled="loading" class="ml-2">
                    Generate Report
                    <i class="fa fa-circle-o-notch fa-spin" v-if="loading"></i>
                </b-button>
            </b-form>
        </b-card>

        <b-card>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th><!-- Day --></th>
                        <th class="hour">12am</th>
                        <th class="hour">2am</th>
                        <th class="hour">4am</th>
                        <th class="hour">6am</th>
                        <th class="hour">8am</th>
                        <th class="hour">10am</th>
                        <th class="hour">12pm</th>
                        <th class="hour">2pm</th>
                        <th class="hour">4pm</th>
                        <th class="hour">6pm</th>
                        <th class="hour">8pm</th>
                        <th class="hour">10pm</th>
                        <th class="rotate"><div><span>Hours</span></div></th>
                        <th class="rotate" v-for="(display,field) in fields"><div><span>{{ display }}</span></div></th>
                        <th class="rotate"><div><span>Risk Score</span></div></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in rows">
                        <td>{{ row.date }}</td>
                        <td colspan="12">
                            <svg width="100%" height="40">
                                <rect :x="getPixels(row.start)" y="10" :width="getPixels(row.hours)" height="6" style="fill:gray" />
                                <circle :cx="getPixels(row.start)" cy="12" r="12" :fill="getColor(row.verified)" />
                                <circle :cx="getPixels(row.start) + getPixels(row.hours)" cy="12" r="12" :fill="getColor(row.verified)" />
                            </svg>
                        </td>
                        <td>{{ row.hours }}</td>
                        <td>
                            <!-- verified -->
                            <svg width="100%" height="25">
                                <circle cx="15" cy="12" r="12" :fill="getColor(row.verified)" />
                            </svg>
                        </td>
                        <td>
                            <!-- modified -->
                            <i class="fa fa-pencil" v-if="row.modified > 0"></i>
                            <span v-else>--</span>
                        </td>
                        <td>
                            <!-- manual -->
                            <span class="declined" v-if="row.manual > 0">+{{ row.hours }}</span>
                            <span v-else>--</span>
                        </td>
                        <td>
                            <!-- increased -->
                            <span class="declined" v-if="row.increased >= 10">+4</span>
                            <span class="declined" v-else-if="row.increased > 0">+1</span>
                            <span v-else>--</span>
                        </td>
                        <td>
                            <!-- disputed -->
                            <i class="fa fa-exclamation-triangle" v-if="row.disputed > 0"></i>
                            <span v-else>--</span>
                        </td>
                        <td>
                            <!-- excessive -->
                            <i class="fa fa-clock-o" v-if="row.excessive > 0"></i>
                            <span v-else>--</span>
                        </td>
                        <td :class="getClassByScore(row.score)">{{ row.score }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <b-row>
                <b-col lg="4">
                    <b-card title="Color Key" class="color_key">
                        Verified:
                        <svg width="25" height="20">
                            <circle :cx="12" cy="12" r="8" :fill="getColor(true)" />
                        </svg>
                        &nbsp;&nbsp;
                        Unverified:
                        <svg width="25" height="20">
                            <circle :cx="12" cy="12" r="8" :fill="getColor(false)" />
                        </svg>
                    </b-card>
                </b-col>
                <b-col lg="4"></b-col>
                <b-col lg="4">
                    <b-card title="Icon Key" class="color_key">
                        Modified: <i class="fa fa-pencil"></i>
                        &nbsp;&nbsp;
                        Disputed: <i class="fa fa-exclamation-triangle"></i>
                        &nbsp;&nbsp;
                        Excessive Length: <i class="fa fa-clock-o"></i>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "FraudRiskReport",
        data() {
            return {
                score: 0,
                fields: {
                    'unverified': 'Verified',
                    'modified': 'Modified',
                    'manual': 'Manually Added',
                    'increased': 'Manually Increased',
                    // 'no_adls': 'No ADLs',
                    'disputed': 'Disputed',
                    'excessive': 'Excessive Length',
                },
                rows: [
                    {
                        date: '10/13/2018',
                        start: 1,
                        hours: 6,
                        verified: true,
                    },
                    {
                        date: '10/15/2018',
                        start: 8,
                        hours: 12,
                        verified: true,
                        excessive: 10,
                        modified: 1,
                        increased: 4,
                        no_adls: 5,
                    },
                    {
                        date: '10/16/2018',
                        start: 18,
                        hours: 3,
                        unverified: 2,
                    },
                    {
                        date: '10/19/2018',
                        start: 4,
                        hours: 4,
                        verified: true,
                    },
                    {
                        date: '10/20/2018',
                        start: 2,
                        hours: 8,
                        unverified: 2,
                        manual: 3,
                    },
                    {
                        date: '10/21/2018',
                        start: 8,
                        hours: 2,
                        verified: true,
                    },
                    {
                        date: '10/22/2018',
                        start: 14,
                        hours: 8,
                        verified: true,
                    },
                    {
                        date: '10/24/2018',
                        start: 10,
                        hours: 6,
                        modified: 1,
                        increased: 10,
                        verified: true,
                    },
                    {
                        date: '10/25/2018',
                        start: 2,
                        hours: 4,
                        disputed: 10,
                        verified: true,
                    },
                ]
            }
        },

        created() {
            this.score = 0;
            this.rows = this.rows.map(row => {
                row.score = 0;
                for(let field in this.fields) {
                    row.score += parseInt(row[field] || 0);
                }
                return row;
            })
        },

        methods: {
            getPixels(hours) {
                // width per hour * hours
                return 30 * hours;
            },
            getColor(val) {
                return val ? 'green' : 'red';
            },
            getClassByScore(val) {
                if (!val) return '';
                return val <= 0 ? 'improved' : 'declined';
            }
        }
    }
</script>

<style scoped>
    .table-bordered {
        width: 95%;
        border: 0;
    }
    i.fa {
        color: #d41313;
        font-size: 20px;
    }
    th.hour {
        width: 30px;
    }
    th.rotate {
        /* Something you can count on */
        height: 127px;
        white-space: nowrap;
        width: 30px;
    }

    th.rotate > div {
        transform:
            /* Magic Numbers */
                translate(25px, 0px)
                    /* 45 is really 360 - 45 */
                rotate(315deg);
        width: 30px;
    }
    th.rotate > div > span {
        border-bottom: 1px solid #ccc;
        padding: 5px 0;
    }
    .improved {
        font-weight: bold;
        color: darkgreen;
    }
    .declined {
        font-weight: bold;
        color: #d41313;
    }
    .color_key .card-title {
        margin-bottom: 0;
    }
    .color_key h4 {
        line-height: 12px;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
    }
</style>